/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import type {
	useMigratedRecentlyMigratedRecentlyQuery as useMigratedRecentlyMigratedRecentlyQuery$data,
	useMigratedRecentlyMigratedRecentlyQueryVariables as useMigratedRecentlyMigratedRecentlyQuery$variables,
} from './__types__/useMigratedRecentlyMigratedRecentlyQuery';

export const useMigratedRecently = (contentId: string) => {
	const { data, loading, error } = useQuery<
		useMigratedRecentlyMigratedRecentlyQuery$data,
		useMigratedRecentlyMigratedRecentlyQuery$variables
	>(
		gql`
			query useMigratedRecentlyMigratedRecentlyQuery($contentId: ID!) {
				content(id: $contentId) {
					nodes {
						id
						metadata {
							frontend {
								migratedRecently
							}
						}
					}
				}
			}
		`,
		{
			variables: { contentId },
		},
	);

	if (loading || error) {
		return false;
	}

	return data?.content?.nodes?.[0]?.metadata?.frontend?.migratedRecently || false;
};
